/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Same_Major_Crab_DelightInputs */

const fr_same_major_crab_delight = /** @type {(inputs: Same_Major_Crab_DelightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

/**

* @param {Same_Major_Crab_DelightInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const same_major_crab_delight = /** @type {((inputs?: Same_Major_Crab_DelightInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Same_Major_Crab_DelightInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_same_major_crab_delight(inputs)
});